import React from 'react';
import { useTranslation } from 'react-i18next';
import { Archive, FileText, Plus } from 'lucide-react';
import PageHeader, { PageHeaderBackButton, PageHeaderButton } from '../../../common/PageHeader';

const truncateName = (firstName, lastName) => {
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
    if (fullName.length <= 30) return fullName;
    return fullName.substring(0, 30) + '...';
};

const CandidateDetailsHeader = ({
    candidateData,
    navigate,
    onExpireInvite,
    onDeleteCandidate,
    onMultiJDSchedule,
    resumeUrl,
}) => {
    const { t } = useTranslation();

    const fullName = candidateData?.first_name && candidateData?.last_name
        ? `${candidateData.first_name} ${candidateData.last_name}`
        : null;
    const displayName = fullName ? truncateName(candidateData.first_name, candidateData.last_name) : t('candidateDetails.title');

    const userRole = localStorage.getItem('role');

    return (
        <PageHeader
            leading={<PageHeaderBackButton onClick={() => navigate(-1)} />}
            title={
                <>
                    {displayName}
                    {userRole === 'Super Admin' && candidateData?.company?.[0]?.name && (
                        <span className="rounded border border-white/30 bg-white/25 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
                            Company: {candidateData.company[0].name}
                        </span>
                    )}
                </>
            }
            subtitle={candidateData?.email || t('candidateDetails.subtitle')}
        >
            {candidateData?.inviteStatus && (
                <span className={`rounded-lg border px-2.5 py-1 text-xs font-semibold ${
                    candidateData?.inviteStatus === 'Active'
                        ? 'border-green-300/50 bg-green-500/20 text-white'
                        : 'border-white/30 bg-white/10 text-white'
                }`}>
                    {candidateData?.inviteStatus === 'Active' ? t('candidateDetails.active') : candidateData?.inviteStatus}
                </span>
            )}
            <PageHeaderButton
                onClick={onMultiJDSchedule}
                title={t('candidateDetails.multiJDScheduleBtn')}
                icon={<Plus size={14} />}
            >
                {t('candidateDetails.multiJDScheduleBtn')}
            </PageHeaderButton>
            {resumeUrl && (
                <PageHeaderButton
                    as="a"
                    href={resumeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={t('candidateDetails.viewResume')}
                    icon={<FileText size={14} />}
                >
                    {t('candidateDetails.viewResume')}
                </PageHeaderButton>
            )}
            {candidateData?.inviteStatus === 'Active' && candidateData?.inviteToken && (
                <PageHeaderButton
                    onClick={() => onExpireInvite(candidateData?.inviteToken)}
                    color="red"
                    title={t('candidateDetails.expireInvite')}
                    icon={<Archive size={14} />}
                >
                    {t('candidateDetails.expireInvite')}
                </PageHeaderButton>
            )}
            <PageHeaderButton
                onClick={onDeleteCandidate}
                color="red"
                title={t('candidateDetails.archiveCandidate')}
                icon={<Archive size={14} />}
            >
                {t('candidateDetails.archiveCandidate')}
            </PageHeaderButton>
        </PageHeader>
    );
};

export default CandidateDetailsHeader;
